
/**
 * 아이템 유형
 */
export type OrderInfoResponseItemType = typeof OrderInfoResponseItemType[keyof typeof OrderInfoResponseItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderInfoResponseItemType = {
  COURSE: 'COURSE',
  SUBSCRIPTION_PLAN: 'SUBSCRIPTION_PLAN',
} as const;
